import { Flex, Heading, Text, Image, Box, Button } from "@chakra-ui/react";
import { FC } from "react";

const Loading: FC = () => {
  return (
    <>
      <Box bg="green.600" h="100vh" overflowY="auto" color="gray.800">
        <Flex
          flexDir="column"
          alignItems="center"
          justifyContent="center"
          bg="green.600"
          borderRadius="8px"
          h="calc(100vh - 8px)"
          p={6}
        >
          <Image
            src="https://assets.website-files.com/5df528ea75e336722a725a71/5df528ea75e3360ae0725ad0_load2.gif"
            width="40%"
          />

          <Heading
            mb={5}
            fontSize={["40px", "40px", "50px"]}
            fontWeight="800"
            color="white"
          >
            Carregando informações ...
          </Heading>

          <br></br>
        </Flex>
      </Box>
    </>
  );
};

export default Loading;
